import { createFileRoute, notFound } from "@tanstack/react-router";
import { DirectoryNotFound, DirectoryPage } from "@/components/directory-page";
import { getDirectoryRegion } from "@/data/directory-pages";
import { filterDirectoryProviders, filterServiceAreaProviders } from "@/lib/directory";
import { directoryHead, type DirectoryPageData } from "@/lib/directory-seo";
import { getPublicProviders } from "@/lib/public-content.functions";

export const Route = createFileRoute("/handwerkerverzeichnis/$region")({
  staticData: { sitemap: true },
  loader: async ({ params }): Promise<DirectoryPageData> => {
    const region = getDirectoryRegion(params.region);
    if (!region) throw notFound();
    const { providers, unavailable } = await getPublicProviders({
      data: { type: "auftragnehmer" },
    });
    return {
      kind: "contractor",
      region,
      providers: filterDirectoryProviders(providers, region),
      serviceAreaProviders: filterServiceAreaProviders(providers, region),
      unavailable,
    };
  },
  head: ({ loaderData }) => directoryHead(loaderData),
  notFoundComponent: DirectoryNotFound,
  component: Page,
});

function Page() {
  const data = Route.useLoaderData();
  return <DirectoryPage key={data.region!.slug} {...data} />;
}
